export default __webpack_public_path__ + "static/media/auth-circle.241492ef.png";